import { useState, useEffect, useCallback } from 'react';
import { getPageMetadata, applyPageMetadata } from '../utils/seoMetadata';
import { trackPageView } from '../utils/analytics';

export function useAppRouter() {
  const [currentPath, setCurrentPath] = useState(() => {
    if (typeof window === 'undefined') return '/';
    // If browser URL has stale hash on root "/" (such as "/#betingelser"), clean it
    if (window.location.pathname === '/' && (window.location.hash === '#betingelser' || window.location.hash === '#dpa' || window.location.hash === '#privatliv')) {
      try {
        window.history.replaceState(null, '', '/');
      } catch (_) {}
      return '/';
    }
    return window.location.pathname + window.location.search + window.location.hash;
  });

  // Apply dynamic SEO title, meta description, and track Page View on current path changes
  useEffect(() => {
    const meta = getPageMetadata(currentPath);
    applyPageMetadata(meta);
    trackPageView(currentPath, meta.title);
  }, [currentPath]);

  useEffect(() => {
    const handlePopState = () => {
      let p = window.location.pathname + window.location.search + window.location.hash;
      if (window.location.pathname === '/' && (window.location.hash === '#betingelser' || window.location.hash === '#dpa' || window.location.hash === '#privatliv')) {
        try {
          window.history.replaceState(null, '', '/');
        } catch (_) {}
        p = '/';
      }
      setCurrentPath(p);
      const meta = getPageMetadata(p);
      applyPageMetadata(meta);
      trackPageView(p, meta.title);
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const navigateTo = useCallback((path: string) => {
    window.history.pushState(null, '', path);
    setCurrentPath(path);
    const meta = getPageMetadata(path);
    applyPageMetadata(meta);
    trackPageView(path, meta.title);
    window.dispatchEvent(new Event('popstate'));
    window.scrollTo(0, 0);
  }, []);

  return {
    currentPath,
    setCurrentPath,
    navigateTo,
  };
}
